<template>
    <div class="fhyxq">
        <div class="content">
            <a-spin :spinning="loading">
                <a-form ref="form" class="fun-edit-form" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
                    <FGCollapsiblePanel title="基本信息">
                        <a-row :gutter="[0, 9]">
                            <a-col :span="8">
                                <a-form-item label="专家姓名">
                                    <a-input ref="zjxm" v-model="editData.zjxm" disabled />
                                </a-form-item>
                            </a-col>
                            <a-col :span="8">
                                <a-form-item label="性别">
                                    <a-input ref="xb" v-model="editData.xb" disabled />
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row :gutter="[0, 9]">
                            <a-col :span="8">
                                <a-form-item label="职称">
                                    <a-input ref="zc" v-model="editData.zc" disabled />
                                </a-form-item>
                            </a-col>
                            <a-col :span="8">
                                <a-form-item label="专业一">
                                    <a-input ref="zymc" v-model="editData.zymc" disabled />
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row :gutter="[0, 9]">
                            <a-col :span="8">
                                <a-form-item label="子专业一">
                                    <a-input ref="zzymc" v-model="editData.zzymc" disabled />
                                </a-form-item>
                            </a-col>
                            <a-col :span="8">
                                <a-form-item label="专业二">
                                    <a-input ref="zymc1" v-model="editData.zymc1" disabled />
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row :gutter="[0, 9]">
                            <a-col :span="8">
                                <a-form-item label="子专业二">
                                    <a-input ref="zzymc1" v-model="editData.zzymc1" disabled />
                                </a-form-item>
                            </a-col>
                            <a-col :span="8">
                                <a-form-item label="单位名称">
                                    <a-input ref="dwmc" v-model="editData.dwmc" disabled />
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row :gutter="[0, 9]">
                            <a-col :span="8">
                                <a-form-item label="职务">
                                    <a-input ref="zw" v-model="editData.zw" disabled />
                                </a-form-item>
                            </a-col>
                            <a-col :span="8">
                                <a-form-item label="手机号码">
                                    <a-input ref="sjhm" v-model="editData.sjhm" disabled />
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row :gutter="[0, 9]">
                            <a-col :span="8">
                                <a-form-item label="学历专业">
                                    <a-input ref="xlzymc" v-model="editData.xlzymc" disabled />
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </FGCollapsiblePanel>
                    <FGCollapsiblePanel title="工作信息">
                        <a-row :gutter="[0, 9]">
                            <a-col :span="12">
                                <a-form-item label="工作业绩" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                                    <a-textarea ref="gzyj" :rows="3" v-model="editData.gzyj" disabled />
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row :gutter="[0, 9]">
                            <a-col :span="12">
                                <a-form-item label="担任外系统评委情况" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                                    <a-textarea ref="drwxtpwqk" :rows="3" v-model="editData.drwxtpwqk" disabled />
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </FGCollapsiblePanel>
                </a-form>
            </a-spin>
        </div>
    </div>
</template>

<script>
export default {
    name: "FhyXQ",
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 主表数据
            editData: {},
            editDataLoading: false
        };
    },
    computed: {
        loading() {
            return this.editDataLoading;
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        // 根据id查询需要编辑的数据
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/jsaec/zjkzjcx/selectById",
                    {
                        id: this.$route.params.id
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.formIsVisible = false;
                    }
                });
        }
    }
};
</script>
<style lang="scss" scoped>
.fhyxq {
    width: 100%;
    height: 100%;
    background-image: url("../../../../assets/images/body_bg.jpg");
    background-repeat: no-repeat;
    .content {
        font-size: 18px;
        margin-left: 450px;
        padding-top: 100px;
    }
}
</style>
